var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 7.05156L14.4372 7.05214L13.9351 7.52596L13.2488 8.17347L12.5625 7.52596L12.0603 7.05214L12.0593 7.05111C10.5813 5.65242 8.11163 5.65246 6.63383 7.05109C5.18719 8.42021 5.18715 10.6117 6.63377 11.9807C6.63377 11.9807 6.63378 11.9807 6.63379 11.9807L13.2212 18.2142C13.2213 18.2143 13.2214 18.2144 13.2216 18.2145C13.2225 18.2151 13.2246 18.2163 13.2281 18.2177C13.2346 18.2202 13.2436 18.2222 13.2544 18.2222C13.2664 18.2222 13.2757 18.2199 13.2816 18.2177C13.2839 18.2168 13.2853 18.216 13.286 18.2156L19.8631 11.9719L19.8634 11.9716C21.3094 10.6004 21.31 8.41909 19.8643 7.05086L14.4379 7.05156ZM14.4379 7.05156C15.1703 6.35931 16.1504 6 17.1511 6M14.4379 7.05156L17.1511 6M17.1511 6C18.1517 6 19.1319 6.35897 19.8642 7.05081L17.1511 6Z",
    stroke: "#3D3E40",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4047b8da2398455418b56b42ab30831f.svg";
export { ForwardRef as ReactComponent };